export default "__VITE_ASSET__18d17e07__"